import styled from 'styled-components';
import { TextLinkExternal } from '@nebula/text-link';

export const TextLinkExternalStyled = styled(TextLinkExternal)<{ $underlineAlways?: boolean }>`
  text-decoration: ${({ $underlineAlways }) => ($underlineAlways ? 'underline' : 'none')};
  font-size: 14px;
`;
